<template>
  <div class="my_info">
    <div class="info_nav">
      <navbar
        title="我的"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        :titlecolor="'#ffffff'"
        :righttext="'订单'"
        :righticonshow="true"
        :righttextStyle="{
          color: '#ffffff',
          'font-size': '1.5rem',
          'line-height': '3.2rem',
        }"
        @goback="goBack(false)"
        @rightclick="goOrder"
      />
    </div>
    <van-row class="box" :style="contentBottom">
      <van-col span="24" class="sign" v-if="showSign" @click="toSign">
        您有合同未签署，请前往签署！<span>去签署 >></span>
      </van-col>
      <van-col span="24" class="device_info">
        <p class="tit">
          我的设备（{{ hasPhone ? "1台" : "0台" }}）
          <span @click="showRule">
            <img src="../../../assets/accountAgent/my/rule_icon.png" />规则说明
          </span>
        </p>
        <div class="deposit_info">
          <p class="info_tit">押金</p>
          <p class="info_num">￥{{ hasPhone ? "2000.00" : "0.00" }}</p>
        </div>
        <div class="deposit_info subsidy">
          <p class="info_tit">红包补贴金额</p>
          <p class="info_num">￥{{ countAmount }}</p>
        </div>
      </van-col>
      <van-col span="24" class="my_info_content" :style="scrollBoxHeight">
        <div class="tabs">
          <div class="tab" :class="{ active: selectFirst }" @click="changeTab1">
            红包补贴记录
          </div>
          <div
            class="tab right"
            :class="{ active: !selectFirst }"
            @click="changeTab2"
          >
            运行停止记录
          </div>
        </div>
        <div class="content" v-if="selectFirst">
          <van-row class="no_list" v-if="list.length == 0">
            <van-col span="24">
              <img src="../../../assets/accountAgent/my/no_info.png" />
            </van-col>
            <van-col span="24" class="tip">暂无数据</van-col>
          </van-row>
          <van-pull-refresh
            v-model="isLoading"
            @refresh="onRefresh"
            v-if="list.length != 0"
          >
            <van-list v-model="loading" :finished="finished" @load="onLoad">
              <van-row>
                <van-col span="24" v-for="(item, index) in list" :key="index">
                  <p class="info_item">
                    <span>{{ item.created_at }}</span>
                    <span class="right">
                      {{
                        item.amount > 0 ? "+" + item.amount : "-" + item.amount
                      }}
                    </span>
                  </p>
                </van-col>
              </van-row>
            </van-list>
          </van-pull-refresh>
        </div>
        <div class="content" v-if="!selectFirst">
          <van-row class="no_list" v-if="list1.length == 0">
            <van-col span="24">
              <img src="../../../assets/accountAgent/my/no_info.png" />
            </van-col>
            <van-col span="24" class="tip">暂无数据</van-col>
          </van-row>
          <van-pull-refresh
            v-model="isLoading1"
            @refresh="onRefresh1"
            v-if="list1.length != 0"
          >
            <van-list v-model="loading1" :finished="finished1" @load="onLoad1">
              <van-row>
                <van-col span="24" v-for="(item, index) in list1" :key="index">
                  <p class="info_item">
                    <span>{{ item.created_at }}</span>
                    <span class="right" v-if="item.status == -1">已停止</span>
                    <span class="right green" v-if="item.status == 1"
                      >运行中</span
                    >
                  </p>
                </van-col>
              </van-row>
            </van-list>
          </van-pull-refresh>
        </div>
      </van-col>
      <van-col span="24" class="button" v-if="canPurchase">
        <btn
          :btntext="'去认领'"
          :btnwidth="'100%'"
          :height="'5rem'"
          :bgcolor="'#F9591B'"
          :borderradius="'2.5rem'"
          :btncolor="'#fff'"
          :fontsize="'1.7rem'"
          :fontweight="500"
          @btnClick="toPurchase"
        />
      </van-col>
    </van-row>
    <van-popup v-model="ruleShow">
      <p class="tit_bg">
        <img src="../../../assets/accountAgent/my/rule_title.png" />
      </p>
      <p class="title">账号代运营规则</p>
      <div class="rule_content">
        <p class="con_title"><span></span>项目背景</p>
        <p class="con">
          销巴会员提供一个账号，由具备运营资质的第三方公司负责该账号的运营推广，再由销巴平台自代运营服务生效后的第4个月开始给予销巴会员300元/月的红包补贴，作为销巴会员提供账号的项目收益。
        </p>
        <p class="con_title"><span></span>押金收取</p>
        <p class="con">
          销巴会员开通代运营服务后，可申请认领一台智能手机，并向销巴平台缴纳2000元押金，缴纳的押金不享受积分赠送。如开通其他社交账号需要缴纳服务费的，缴费标准与申退规则以相关平台为准。
        </p>
        <p class="con_title"><span></span>押金退回</p>
        <p>
          销巴平台与会员均拥有单方面终止账号代运营服务的权利。如代运营服务终止，2000元押金原路退回或退回至会员余额。
        </p>
        <p class="con">
          关于认领手机的特别注意事项：在代运营服务终止后，销巴会员需将智能手机寄送至平台指定地址，并确保手机无软硬件损坏。如认领的手机在使用期间存在部分软硬件损坏，则平台退还部分押金（具体退还比例由专属客服与会员沟通协商）；如遗失手机，则平台按当时市场价格扣除保证金。
        </p>
        <p class="con_title"><span></span>签订协议</p>
        <p class="con">
          销巴会员作为代运营账号的持有者，需与销巴平台、第三方公司在销巴生活APP上签订三方电子协议。协议详情，请移步相应页面查看。
        </p>
      </div>
      <img
        class="close"
        @click="closePopup"
        src="../../../assets/accountAgent/my/rule_close.png"
      />
    </van-popup>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/my/reback.png"),
      canPurchase: false, //默认不展示去认领按钮
      btnAddHeight: 0, //若展示去认领按钮则此值为78
      contentBottom: { "padding-bottom": "1.2rem" }, //不展示去认领按钮时底部padding
      scrollBoxHeight: {
        height: (document.body.clientHeight - 278) / 10 + "rem",
      },
      showSign: false, //默认不展示签署合同模块
      showSignAddHeight: 0, //若展示签署合同模块则此值为48
      selectFirst: true,
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
      page: 1,
      pageSize: 10,
      allList: 16, //默认比第一页数据多1
      list1: [],
      loading1: false,
      finished1: false,
      isLoading1: false,
      page1: 1,
      pageSize1: 10,
      allList1: 16, //默认比第一页数据多1
      ruleShow: false,
      hasPhone: false,
      signOrdersn: "",
      countAmount: "0.00",
    };
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    this.getInfo();
    this.getList();
  },
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
  },
  methods: {
    showRule() {
      this.ruleShow = true;
    },
    closePopup() {
      this.ruleShow = false;
    },
    changeTab1() {
      if (!this.selectFirst) {
        this.selectFirst = !this.selectFirst;
        this.page = 1;
        this.allList = 16;
        this.list = [];
        this.finished = false;
        this.getList(); //红包补贴记录
      }
    },
    changeTab2() {
      if (this.selectFirst) {
        this.selectFirst = !this.selectFirst;
        this.page1 = 1;
        this.allList1 = 16;
        this.list1 = [];
        this.finished1 = false;
        this.getList1(); //运行停止记录
      }
    },
    getInfo() {
      this.$api.post("/investment/member/agent/config/detail").then((res) => {
        this.countAmount = res.count_amount;
        if (res.member_status.is_order == 1) {
          this.hasPhone = true;
        }
        if (
          res.member_status.is_order == 1 &&
          res.member_status.is_contract == 0
        ) {
          //有合同待签署时展示签署合同模块
          this.showSign = true;
          this.showSignAddHeight = 48;
          this.signOrdersn = res.ordersn;
        }
        if (res.member_status.is_order == -1) {
          //已退订时展示去认领按钮
          this.canPurchase = true; //this.canPurchase(scrollBoxHeight-78)
          this.btnAddHeight = 78;
          this.contentBottom = { "padding-bottom": "9rem" };
        }

        this.scrollBoxHeight.height =
          (document.body.clientHeight -
            278 -
            this.btnAddHeight -
            this.showSignAddHeight) /
            10 +
          "rem";
      });
    },
    getList() {
      this.$api
        .post("investment/member/agent/order/settle/log/list", {
          page: this.page,
        })
        .then((res) => {
          this.allList = res.total;

          if (res.list.length > 0) {
            for (let i in res.list) {
              this.list.push(res.list[i]);
            }
          }
          this.loading = false;
          if (this.list.length >= this.allList) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        });
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getList();

        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.list = [];
      this.getList();
    },
    getList1() {
      this.$api
        .post("investment/member/agent/Member/logs", { page: this.page1 })
        .then((res) => {
          this.allList1 = res.total;

          if (res.list.length > 0) {
            for (let i in res.list) {
              this.list1.push(res.list[i]);
            }
          }
          this.loading1 = false;
          if (this.list1.length >= this.allList1) {
            // 数据全部加载完成
            this.finished1 = true;
          }
          if (this.isLoading1) {
            this.$toast("刷新成功");
            this.isLoading1 = false;
          }
        });
    },
    onLoad1() {
      // 异步更新数据
      setTimeout(() => {
        this.page1++;
        this.getList1();

        // 加载状态结束
        this.isLoading1 = false;
      }, 500);
    },
    onRefresh1() {
      this.page1 = 1;
      this.finished1 = false;
      this.list1 = [];
      this.getList1();
    },
    goBack() {
      this.params("", "", "goBack");
    },
    goOrder() {
      this.$router.push("/accountAgent/order");
    },
    toSign() {
      this.$router.push({
        path: "/accountAgent/signContract",
        query: {
          ordersn: this.signOrdersn,
          from: "h5",
        },
      });
    },
    toPurchase() {
      this.$router.push("/accountAgent/rule");
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.my_info {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .van-popup--center {
    width: 27.4rem;
    // height: 44rem;
    padding: 0 1.5rem 1.5rem;
    border-radius: 0.3rem;
    overflow: visible;

    .tit_bg {
      height: 2.9rem;
      text-align: center;
      margin-bottom: 0.9rem;

      img {
        display: inline-block;
        width: 18.5rem;
        height: 2.9rem;
      }
    }

    .title {
      color: #fff;
      text-align: center;
      height: 2.9rem;
      line-height: 2.9rem;
      font-size: 1.5rem;
      font-weight: 700;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }

    .rule_content {
      color: #666;
      font-size: 1.4rem;
      line-height: 2.4rem;
      letter-spacing: 2px;
      height: 38.1rem;
      scrollbar-width: none; /* firefox */
      -ms-overflow-style: none; /* IE 10+ */
      overflow-y: scroll;

      .con_title {
        font-weight: 700;
        margin-top: 0.6rem;

        span {
          width: 0.4rem;
          height: 0.4rem;
          border-radius: 0.2rem;
          background: rgba(102, 102, 102, 0.8);
          margin-right: 0.5rem;
          float: left;
          margin-top: 1rem;
        }
      }

      .con {
        line-height: 2.2rem;
      }
    }

    .rule_content::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }

    .close {
      width: 2.6rem;
      position: absolute;
      left: 12.4rem;
      bottom: -4.6rem;
    }
  }

  .info_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #f9591b;
    z-index: 3;
  }

  .box {
    padding: 10rem 1.2rem 0;
    box-sizing: border-box;
    height: 100%;
    background: url(../../../assets/accountAgent/my/myBG.png) no-repeat top
      center;
    background-size: 100%;
    position: relative;

    .sign {
      height: 3.6rem;
      line-height: 3.6rem;
      padding: 0 1.2rem 0 2rem;
      border-radius: 0.6rem;
      background: rgba(255, 255, 255, 0.8);
      color: #f9591b;
      font-size: 1.6rem;
      text-align: left;
      margin-bottom: 1.2rem;

      span {
        float: right;
      }
    }

    .device_info {
      width: 100%;
      height: 15.6rem;
      border-radius: 0.6rem;
      background: #fff;
      color: #333;
      font-weight: 700;
      font-size: 1.6rem;
      margin-bottom: 1rem;

      .tit {
        color: #333;
        font-size: 1.6rem;
        text-align: left;
        padding: 2rem;
        height: 2.2rem;
        line-height: 2.2rem;
        border-bottom: solid 0.1rem #eeeeee;
        margin-bottom: 1.9rem;

        span {
          float: right;
          color: #999;
          font-size: 1.4rem;
          font-weight: 400;

          img {
            width: 1.6rem;
            margin-right: 0.5rem;
            vertical-align: middle;
          }
        }
      }

      .deposit_info {
        width: 50%;
        text-align: center;
        display: inline-block;
        margin-bottom: 1rem;

        .info_tit {
          color: #999;
          font-size: 1.4rem;
          height: 2rem;
          line-height: 2rem;
          margin-bottom: 0.6rem;
          font-weight: 400;
        }

        .info_num {
          color: #333;
          font-size: 2.4rem;
          font-weight: 700;
        }
      }

      .subsidy {
        float: right;
        .info_num {
          color: #f9591b;
        }
      }
    }

    .my_info_content {
      box-sizing: border-box;
      font-size: 1.4rem;
      background: #fff;
      border-radius: 0.6rem;

      .tabs {
        height: 3.6rem;
        padding: 2rem 1.2rem 0.8rem;
        font-size: 1.5rem;
        .tab {
          width: 15.8rem;
          height: 3.6rem;
          line-height: 3.6rem;
          border-radius: 1.8rem;
          text-align: center;
          background: #f5f6f7;
          color: #666;
          display: inline-block;
        }

        .right {
          float: right;
        }

        .active {
          background: #f9591b;
          color: #fff;
        }
      }

      .content {
        height: calc(100% - 6.4rem);
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        padding: 0 1.2rem;

        .no_list {
          text-align: center;

          img {
            width: 22.1rem;
            margin-top: 5.7rem;
          }

          .tip {
            color: #999;
            font-size: 1.5rem;
            line-height: 6rem;
          }
        }

        .info_item {
          height: 5rem;
          line-height: 5rem;

          span {
            color: #999;
            display: inline-block;
            text-align: center;
            width: 15.8rem;
          }

          .right {
            float: right;
            color: #f9591b;
          }

          .green {
            color: #35a984;
          }
        }
      }
    }

    .button {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 0 1.2rem 0.4rem;
    }
  }
}
</style>


